import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
import placeholder from '../_placeholders/-assets/placeholder-settings.png';
export const Route = createFileRoute('/_staff/licenses/_list/settings/')({
  component: () => <ComingSoonCover placeholderImage={placeholder} />
});